import { forwardRef } from 'react';

import { css, cx } from '@/styled-system/css';

import { dropdownFooterStyles } from './styles/dropdown-footer.styles';
import type { DropdownFooterPropsInterface } from './types/dropdown-footer.types';

/**
 * @since 10.0.0
 */
export const DropdownFooter = forwardRef<HTMLDivElement, DropdownFooterPropsInterface>(
  (props: DropdownFooterPropsInterface, forwardedRef) => {
    const { children, className, css: cssProp, ...rest } = props;
    const styles = css(dropdownFooterStyles, cssProp);

    return (
      <div
        ref={forwardedRef}
        data-c11n-version={__C11N_VERSION__}
        data-c11n-component="Dropdown.Footer"
        className={cx('c11n', 'c11n_dropdown__footer', styles, className)}
        {...rest}
      >
        {children}
      </div>
    );
  },
);

DropdownFooter.displayName = 'Dropdown.Footer';
